import { render, staticRenderFns } from "./search-contacts.vue?vue&type=template&id=3ed47e9d&scoped=true&"
import script from "./search-contacts.vue?vue&type=script&lang=js&"
export * from "./search-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed47e9d",
  null
  
)

export default component.exports